import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, mergeMap, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { GeoPosActionService } from '../core/geographicalpos/geographicalpos.action';
import { Observable, of } from 'rxjs';
import { select } from '@angular-redux/store';
import { GeoPos } from '../core/geographicalpos/geographicalpos.model';
import { Itin } from '../core/itinerari/itinerari.model';
import { ItinActionService } from '../core/itinerari/itinerari.action';
import { PaginatedItin } from '../shared/models/paginated-itin.model';

@Injectable()
export class SingleAreaItinerariesResolver implements Resolve<Itin[]> {
  geoposNames = {
    cimbri: 'Cimbri dell\'Altopiano dei Sette Comuni',
    friuli: 'Friulani in Veneto',
    'italiani-in-slovenia': 'Italiani in Slovenia',
    ladini: 'Ladini del Comelico',
    'sloveni-in-italia': 'Sloveni in Italia',
    'friuli-fvg': 'Friulani in Friuli Venezia Giulia'
  };
  @select(['itin', 'list'])
  itinList$: Observable<Itin[]>;
  @select(['geopos', 'list'])
  geoposList$: Observable<GeoPos[]>;
  singleGeopos: GeoPos;
  isGeoposInRedux = false;

  constructor(private service: ApiService,
              private itinAction: ItinActionService,
              private geoposAction: GeoPosActionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.geoposList$.pipe(
      first(),
      mergeMap((list) => {
        if (list.length > 0) {
          this.isGeoposInRedux = true;
          return of(list);
        }
        return this.service.getGeoPos().pipe(first());
      }),
      mergeMap((list: any) => {
        let geoposList;
        if (this.isGeoposInRedux) {
          geoposList = [...list];
        } else {
          geoposList = GeoPos.fromArray(list);
          this.geoposAction.geoposList(geoposList);
        }

        const nameFromUrl = state.url.split('/').pop();
        this.singleGeopos = geoposList.filter((geopos: GeoPos) =>
          geopos.name.it.includes(this.geoposNames[nameFromUrl]))[0];
        this.geoposAction.setGeoPosCurrent(this.singleGeopos);

        return this.service.getItin(
          0,
          this.singleGeopos.id,
          null,
          null,
          null,
          true
        ).pipe(first());
      }),
      tap((paginatedItin: PaginatedItin) => {
        this.itinAction.paginatedItinList(paginatedItin);
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di itinerari di una singola area');
        return of(err);
      })
    );
  }
}
